import type { DepartmentDTO, PayerDTO } from '@/api/trafikportalen';

export const getDepartmentPayer = (
  department: DepartmentDTO | string,
  allDepartments: DepartmentDTO[],
  payers?: PayerDTO[],
): PayerDTO | undefined => {
  if (typeof department === 'string') {
    department = allDepartments.find(
      (d) => d.id === department,
    ) as DepartmentDTO;
    if (!department) {
      return undefined;
    }
  }

  if (department.payer_id && payers) {
    const payer = payers.find((payer) => payer.id === department.payer_id);
    if (payer) {
      return payer;
    }
  }

  const parentDepartment = allDepartments.find(
    (d) => d.id === department.parent_id,
  );

  if (parentDepartment) {
    return getDepartmentPayer(parentDepartment, allDepartments, payers);
  }

  return undefined;
};
